<dx-lookup #artifactLookup
  appFieldsetSupport
  (inheritedDisabledChange)="isReadOnly = $event"
  [dataSource]="artifactDataSource"
  [disabled]="isReadOnly"
  [showClearButton]="true"
  [value]="selectedArtifact"
  (onValueChanged)="artifactSelectedInternal($event)"
  [displayExpr]="displayExpr">

  <dxo-drop-down-options [showTitle]="false"></dxo-drop-down-options>

  <div *dxTemplate="let artifact of 'item'">
    <div class="the-grid">
      <div>
        <h3>
          @if (artifact.IsSystemArtifact) {
            <span class="system dx-icon-check"
            title="This artifact is a 'System Artifact'"></span>
          }
          <span>{{artifact.Name}}</span>
        </h3>
      </div>
      <div><p>Description:</p></div>
      <div><p>{{artifact.Description}}</p></div>
      <div><p>Filename:</p></div>
      <div><p class="italic">{{artifact.Filename}}</p></div>
      <div><p>Assembly:</p></div>
      <div><p class="italic">{{artifact.AssemblyName}}</p></div>
      <div><p>Class:</p></div>
      <div><p class="italic">{{artifact.ClassName}}</p></div>
    </div>
  </div>
</dx-lookup>
@if (loadingArtifactDetails) {
  <span>
    <img src="../../images/ajax-loader.gif" alt="Loading artifact details..." /> Loading artifact details...
  </span>
}
